import "./Contact.css";
import React, { useState, useRef, useEffect } from "react";
import Footer from "./Footer";
import Tada from "react-reveal/Tada";
import Fade from "react-reveal/Fade";

const Contact = (props) => {
  const [copy, setCopy] = useState(false);
  const copyRef = useRef(null);
  const [classes, setClasses] = useState("clipboard");

  useEffect(() => {
    setClasses("clipboard clicked");
    copyRef.current = setTimeout(() => {
      setClasses("clipboard");
    }, 2500);
    return () => {
      setClasses("clipboard");
      clearTimeout(copyRef.current);
    };
  }, [copy]);

  const telephone = () => {
    navigator.clipboard.writeText("+65 8770 6386");
    setCopy((copy) => !copy);
  };
  const email = () => {
    navigator.clipboard.writeText("laushaowei@gmail.com");
    setCopy((copy) => !copy);
  };
  const address = () => {
    navigator.clipboard.writeText("38, Nanyang Crescent, 636866 Singapore");
    setCopy((copy) => !copy);
  };

  return (
    <Fade left>
      <div id={props.id} className="contact-container">
        <p id="clip" className={classes}>
          Copied to Clipboard✅
        </p>
        <h1 className="contact-title">Contact me</h1>
        <hr></hr>
        <div className="contact-detail">
          <p className="contact-item">
            <i class="contact-icon bi bi-telephone"></i>
            <button onClick={telephone}>+65 8770 6386</button>
          </p>
          <p className="contact-item">
            <i class="contact-icon bi bi-inbox"></i>
            <button onClick={email}>laushaowei@gmail.com</button>
          </p>
          <p className="contact-item">
            <i class="contact-icon bi bi-geo"></i>
            <button onClick={address}>
              38, Nanyang Crescent, 636866 Singapore
            </button>
          </p>
        </div>
        <Tada>
          <div className="colz-icon">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/iamshaoweixD/"
            >
              <i className="bi bi-facebook dark"></i>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/shaowei.925/"
            >
              <i class="bi bi-instagram"></i>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/swl925/"
            >
              <i className="bi bi-linkedin"></i>
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/shaowei0925"
            >
              <i className="bi bi-github"></i>
            </a>
          </div>
        </Tada>
        <Footer />
      </div>
    </Fade>
  );
};

export default Contact;
